import './client-details.scss'

import { useRef } from 'react'

import { ApiDfmWithUsers } from '@/api/_legacy/generated-api'
import { Label, Space, TextInput, ValidationMessage } from '@/components/core-v2'

import { isErrorWith } from '../common'
import { Mutation } from '../types'
import { mutateDfmName } from './utils/mutate-dfm-name'

export type Props = {
  dfmName: string
  errors?: { [key: string]: string }
  onMutate: (mutation: Mutation<ApiDfmWithUsers>) => void
}

export const DfmEditor = ({ dfmName, errors, onMutate }: Props) => {
  const previousDfmName = useRef(null)

  const onDfmNameChange = (updatedValue: any) => {
    if (previousDfmName.current === updatedValue) return
    mutateDfmName(onMutate, updatedValue)
    previousDfmName.current = updatedValue
  }

  return (
    <Space mx={5} my={6}>
      <Space mb={6}>
        <Space mb={3}>
          <Label>Portfolio manager name *</Label>
        </Space>
        <TextInput
          isError={isErrorWith(errors, 'dfmName')}
          maxLength={64}
          value={dfmName}
          onDebouncedValue={onDfmNameChange}
        />
        <ValidationMessage errors={errors} fieldName="dfmName" />
      </Space>
    </Space>
  )
}
